/**
 * The mask shorthand for one mark's file. Quoted: Vite inlines a small SVG as a
 * `data:` URL whose markup keeps single quotes and braces; unquoted, `url(...)`
 * is invalid CSS, the browser drops the whole mask, and the box paints as a
 * plain square. Vite never emits a double quote inside one, so double quotes
 * are safe.
 */
export function brandMaskFor(src: string): string {
  return `url("${src}") no-repeat center / contain`;
}
